var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", { attrs: { active: _vm.loading, "is-full-page": true } }),
      _c(
        "div",
        { staticClass: "pa-3", attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-card",
            { staticClass: "mb-3", attrs: { align: "left", justify: "left" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "primary--text lighten-2 pa-2" },
                    [_vm._v(" mdi-tag-multiple-outline ")]
                  ),
                  _vm._v(" Administração > Manutenção de Espécies de Títulos ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "pa-3" },
            [
              _c(
                "v-card-actions",
                { staticClass: "pb-0" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: _vm.loading,
                        "data-cy": "btnNovaEspecie"
                      },
                      on: { click: _vm.abrirModalNovaEspecie }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-plus")
                      ]),
                      _vm._v(" Nova Espécie de Título ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-1 mt-2",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.especies,
                  loading: _vm.loading,
                  "footer-props": {
                    itemsPerPageOptions: [10, 20, 50, 100],
                    itemsPerPageText: "Itens por página:"
                  },
                  "item-key": "cd_especie_titulo",
                  "server-items-length": _vm.totalItems,
                  page: _vm.currentPage,
                  "items-per-page": _vm.itemsPerPage
                },
                on: {
                  "update:page": [
                    function($event) {
                      _vm.currentPage = $event
                    },
                    _vm.carregarDados
                  ],
                  "update:itemsPerPage": function($event) {
                    _vm.itemsPerPage = $event
                  },
                  "update:items-per-page": [
                    function($event) {
                      _vm.itemsPerPage = $event
                    },
                    _vm.carregarDados
                  ]
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.requer_anexo`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                color: item.requer_anexo
                                  ? "success"
                                  : "default",
                                small: "",
                                outlined: ""
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(item.requer_anexo ? "Sim" : "Não") +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: `item.acoes`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  color: "primary",
                                                  "data-cy": "btnEditar"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.abrirModalEdicao(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("v-icon", [_vm._v("mdi-pencil")])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v("Editar")])]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.modalAtivo
        ? _c("ModalEspecieTitulo", {
            attrs: {
              showModal: _vm.modalAtivo,
              especie: _vm.especieSelecionada
            },
            on: {
              fecharModal: _vm.fecharModal,
              mostrarMensagem: _vm.mostrarMensagem,
              atualizarLista: _vm.carregarDados
            }
          })
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: _vm.snackbarColor,
            timeout: "5000",
            top: "",
            right: ""
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            _vm.snackbar = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Fechar ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.snackbarMessage) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }